import { Box, Typography, MediaBox, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import Slider from "dependencies/carousel"

import { faqData } from "./data"

const CarouselWrapper = styled(MediaBox).attrs((props) => ({
  height: "190px",
  lessThan: "tablet",
  mb: 6,
  mx: 2,
  ...props,
}))``

const SliderWrapper = styled(Slider)`
  button[aria-label="next"],
  button[aria-label="previous"] {
    top: 112px;
  }
`

const ArrowImg = styled(Image)`
  margin: 0 auto;
  position: relative;
`

const Arrow = ({ next }) => {
  return (
    <ArrowImg
      alt={`Go to ${next ? "next" : "previous"} review`}
      className="lazyload"
      data-src={require("images/icons/arrow_left_dark.svg")}
      height="26px"
      src={require("images/icons/jewlr.gif")}
      width="15px"
    />
  )
}

Arrow.propTypes = {
  next: PropTypes.bool,
}

const FAQCarousel = () => {
  const sliderSettings = {
    defaultControlsConfig: {
      nextButtonText: <Arrow next />,
      prevButtonText: <Arrow />,
    },
    dots: false,
    frameAriaLabel: "Warranty FAQ",
    speed: 200,
  }

  return (
    <CarouselWrapper>
      <SliderWrapper {...sliderSettings}>
        {faqData().map((faq, ix) => (
          <Box key={`${faq.name}-${ix}`} px={6} textAlign="center">
            <Typography as="h1" fontSize="16px" pb={2}>
              {faq.title}
            </Typography>
            <Typography>{faq.text}</Typography>
          </Box>
        ))}
      </SliderWrapper>
    </CarouselWrapper>
  )
}
FAQCarousel.propTypes = {
  warrantyData: PropTypes.array,
}

export default FAQCarousel
